import { Component, OnInit, ViewContainerRef } from '@angular/core';
import {AuthenticationService} from "./authentication/authentication.service";
import {ToastrService} from "ngx-toastr";
import { ActivatedRoute, Event, NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { HybridToolsService } from './core/services/hybrid-tools.service';
import {ProgressService} from "./core/services/progress.service";
import {Util} from "./common/util";
import {UiStateService} from "./core/services/ui-state.service";
import {EventService} from "./core/services/event.service";
import { Keyboard } from '@capacitor/keyboard';
import { StatusBar, Style } from '@capacitor/status-bar';
import {Platform} from '@ionic/angular';
import { Angulartics2GoogleAnalytics } from 'angulartics2';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    providers: []
})
export class AppComponent implements OnInit {
    constructor(
        public toastr: ToastrService,
        public vRef: ViewContainerRef,
        public route: ActivatedRoute,
        public authService: AuthenticationService,
        public eventService: EventService,
        public uiStateService: UiStateService,
        public router: Router,
        public angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
        public progressService: ProgressService,
        public hybridToolsService: HybridToolsService,
        private platform: Platform
    ) {
        //FIXME: migration
        //this.toastr.setRootViewContainerRef(vRef);
        angulartics2GoogleAnalytics.startTracking();
        router.events.subscribe((e: Event) => {
            if (e instanceof NavigationStart) {
                this.hybridToolsService.removeMobileMenuClasses();
                this.hybridToolsService.enableBodyScroll();
            }

            if (e instanceof RoutesRecognized) {
                if (e.state.root.queryParams['impersonationTargetUser']) {
                    sessionStorage.setItem('impersonationTargetUser', e.state.root.queryParams['impersonationTargetUser'])
                }
            }
            // NavigationEnd
            // NavigationCancel
            // NavigationError
            // RoutesRecognized
        });

        this.initializeCapacitor();
    }

    ngOnInit() {
        this.eventService.setCampaignById(Util.getParameterByName('ProgramGroup'));
        this.uiStateService.showUpdatePassword(Util.getParameterByName('pwToken'));
    }

    initializeCapacitor() {
        this.platform.ready().then(() => {
            if (this.platform.is('capacitor')) {
                if (this.hybridToolsService.isIOS()) {
                    StatusBar.setStyle({ style: Style.Light });

                    //Capacitor hides the accessory bar by default, (this results in a missing 'done' button for ios select controls)
                    Keyboard.setAccessoryBarVisible({isVisible: true});
                }
            }
        });
    }
}
